import LoadsImportResult from './loads-import-result';

export default LoadsImportResult;
